/* eslint-disable */
// Generated by scripts/generate-legacy-messages.mjs — do not edit by hand.

export const legacyMessageSource = {
  "ACCOUNT_LOCKED": "Account Locked",
  "ACCOUNT_NUMBER": "Account Number",
  "ADDITIONAL_INFORMATION": "Additional Information",
  "ADDRESS": "Address",
  "ADDRESS_NO_REPEATING_SPECIAL_CHARS": "Don't repeat the same symbol (for example, avoid #### or ////).",
  "ADDRESS_POSTAL_INVALID_CHARS": "Only letters, numbers, spaces, and these characters are allowed: # / ' - ( ) \"",
  "AMOUNT_ENTRY_FEES": "Fees",
  "AMOUNT_ENTRY_RECEIVE_CURRENCY": "Receive currency",
  "AMOUNT_ENTRY_SUBTITLE": "Instant and free options available",
  "AMOUNT_ENTRY_THEY_RECEIVE": "They receive",
  "AMOUNT_ENTRY_TOTAL": "Total",
  "AMOUNT_ENTRY_YOU_SEND": "You send",
  "AVAILABLE": "Available",
  "AVAILABLE_FOR_PICKUP": "Available for pickup",
  "BILLS": "bills",
  "CALL_NOW": "Call now",
  "CASH": "cash",
  "CASH_AT_LOCATION": "Cash at location",
  "CHOOSE_CURRENCY_YOUR_RECEIVER_GETS": "Choose the currency your receiver gets",
  "CHOOSE_STATE_OF_ID": "Choose State of ID",
  "CHOOSE_WHAT_STATE_YOU_ARE_SENDING_TO": "Choose what state you’re sending to",
  "CONFIRM": "Confirm",
  "CONTINUE_AS_GUEST": "Continue as guest",
  "COUNTRY_STEP_SEARCH_PLACEHOLDER": "Search",
  "COUNTRY_STEP_SUBTITLE": "Choose what country you're sending to",
  "COUNTRY_STEP_TITLE": "Choose country",
  "CVS_STORE_LOCATION": "CVS Store Location",
  "DESTINATION": "Destination",
  "DESTINATION_STATE": "Destination State",
  "DISCLAIMER": "Disclaimer",
  "DOB": "DOB",
  "EDIT": "Edit",
  "ENGLISH": "English",
  "ENTER_YOUR_ZIP_CODE": "Please enter your zip code",
  "EXCHANGE_RATE": "Exchange rate: 1 USD =",
  "EXHANGE_RATE": "Exchange rate",
  "EXPLORE_RATE_AND_FEES": "Explore rates and fees",
  "FEES": "Fees",
  "FETCHING_FEES": "Fetching fees...",
  "FIRST_NAME": "First name",
  "FRAUD_BRIEF_INFO": "Keep your money safe. If any of the below apply, DO NOT SEND the money transfer. It’s a scam and someone is trying to steal your money. If you send money, it can be paid out quickly, and you may not be able to get a refund.",
  "FRAUD_CONFIRMATION": "Are you sending money for something a telemarketer sold you?",
  "FRAUD_FIRST_POINT": "To donate to a charity or to pay an internet merchant during a crisis",
  "FRAUD_FOURTH_POINT": "To buy a car, paragraph or other high-value item, or for “escrow” for housing",
  "FRAUD_PREVENTION_TITLE": "Fraud prevention",
  "FRAUD_PRE_CONCLUSION": "Sellers and telemarketers can’t take money transfer payments from people in the US for something they’re selling.",
  "FRAUD_PRE_CONTACT": "If you feel like you are a victim of fraud please call 1-800-926-9400 for assistance or visit www.moneygram.com and file a complaint.",
  "FRAUD_SECOND_POINT": "To receive money (e.g., lottery winnings, prizes or job offers)",
  "FRAUD_SUBTITLE": "Fraud warning about your money transfer",
  "FRAUD_THIRD_POINT": "To pay the IRS or police",
  "GET_STARTED": "Get started",
  "HEAD_TO_CASHIER": "Head to the cashier!",
  "HOW_MUCH_ARE_YOU_RECEIVING": "How much are you receiving?",
  "HOW_THEY_PICK": "How They Receive",
  "HOW_THEY_RECEIVE_INFO": "Transfer speed depends on the delivery method, transaction review, and system availability of MoneyGram and its partners.",
  "IDENTIFICATION_TYPE_CONTINUE": "Continue",
  "IDENTIFICATION_TYPE_SUBTITLE": "Select how you’d like to verify your identity.",
  "IDENTIFICATION_TYPE_TITLE": "Your identification type",
  "ID_NUMBER": "ID Number",
  "ID_NUMBER_INVALID_CHARS": "Only letters, numbers, and hyphens are allowed (no spaces or other symbols).",
  "IS_THIS_THEIR_LEGAL_NAME": "Is this their legal name?",
  "I_AM_FINISHED": "I’m finished",
  "LAST_NAME": "Last name(s)",
  "LEGAL_NAME": "Legal name",
  "LET_THE_CASHIER_KNOW": "Let the cashier know you need to complete a MoneyGram transaction",
  "LOADING_COUNTRIES": "Loading countries…",
  "LOOK_UP_SUBTITLE": "Enter the reference number associated with your money transfer at this location.",
  "LOOK_UP_TRANSFER": "Look up your transfer",
  "MAKE_SURE_THEIR_NAME_MATCHES": "Make sure their name matches what’s on their  legal ID, so they can receive their transfer on time or pick up cash at location.",
  "MAKE_SURE_TO_USE_NAME_ON_YOUR_LEGAL_ID": "Make sure to use the name on your legal ID.",
  "MIDDLE_NAME": "Middle name (optional)",
  "NEED_HELP": "Need help?",
  "NEED_HELP_INFO": "Our customer service team is available to answer your questions 24/7 at (800) 794-2805.",
  "NICKNAME": "Nickname (optional)",
  "NO_COUNTRIES_LOADED": "No countries loaded",
  "PAY": "Pay",
  "PAYMENT": "Payment",
  "PAYMENT_POST": "Payments generally post within 2 to 3 business days.",
  "PAYMENT_RECEIVED_INFORMATION": "Payments received after 11:59 PM CST are generally credited the next business day.",
  "PAY_AMOUNT": "Pay amount",
  "PAY_BILLS": "Pay bills",
  "PERSON_NAME_ERROR_FIRST_REQUIRED": "First name is required",
  "PERSON_NAME_ERROR_LAST_REQUIRED": "Last name is required",
  "PERSON_NAME_ERROR_LETTERS_ONLY": "Use only letters. Numbers and special characters are not allowed.",
  "PERSON_NAME_ERROR_MAX_CHARS": "Use at most {count} characters.",
  "PHONE_NUMBER": "Mobile Number",
  "PHONE_STEP_ERROR_FAILED": "Failed to continue. Please try again.",
  "PHONE_STEP_ERROR_INVALID": "Please enter a 10-digit phone number.",
  "PHONE_STEP_ERROR_MISSING_LOCATION": "Missing location details. Please try again later.",
  "PHONE_STEP_PLACEHOLDER": "Mobile number",
  "PHONE_STEP_SUBTITLE": "Enter your phone number",
  "PHONE_STEP_TITLE": "Your phone number",
  "PICK_UP": "Pick up",
  "PICK_UP_CASH": "Pick up cash",
  "PIN_CONFIRM_ERROR": "PIN must be exactly 4 digits",
  "PIN_CONFIRM_SUBTITLE": "Create a PIN to save your information",
  "PIN_CONFIRM_TITLE": "Confirm your PIN",
  "PIN_CREATED": "PIN created",
  "PIN_INPUT_ERROR": "PIN must be exactly 4 digits",
  "PIN_INPUT_SUBTITLE": "Create a PIN to save your information",
  "PIN_INPUT_TITLE": "Enter a PIN",
  "PLEASE_ENTER_AMOUNT": "Please enter amount into field.",
  "POWERED_BY": "Powered by",
  "PREPARING_SHARE": "Preparing share …",
  "PROMOCODE_ERROR_OCCURRED": "Invalid promo code",
  "PROMO_CODE": "Promo code",
  "PROVIDE_DETAILS_ABOUT_YOUR_RECEIVER": "Provide details about your receiver",
  "PROVIDE_YOUR_PHOTO_ID_NUMBER": "Provide your photo ID number",
  "PROVIDE_YOUR_RRN_NUMBER": "Provide your RRN number",
  "QR_DETAILS_MISSING": "A few QR details are missing. Scan it again to proceed.",
  "RECEIVER_DETAILS": "Receiver details",
  "RECEIVER_DOB_SUBTITLE": "This information will help speed up the payout.",
  "RECEIVER_NAME": "Receiver",
  "RECEIVE_AMOUNT": "Receive Amount",
  "RECEIVE_METHOD_DELIVERY_OPTION": "Delivery option",
  "RECEIVE_METHOD_ERROR": "Error loading options",
  "RECEIVE_METHOD_LOADING": "Loading options...",
  "RECEIVE_METHOD_NO_OPTIONS": "No delivery options available.",
  "RECEIVE_METHOD_TITLE": "How they receive",
  "RECENT": "Recent",
  "REFERENCE": "Reference #",
  "REFERENCE_NUMBER": "Reference Number",
  "REFERENCE_SAMPLE": "Sample: (8 digits) 12345678",
  "REMEMBER_PIN": "Remember your PIN for secure access and money transfers.",
  "RESET_PIN": "Reset PIN",
  "REVIEW_AVAILABLE": "Available",
  "REVIEW_DESTINATION_COUNTRY": "Destination Country",
  "REVIEW_EXCHANGE_RATE": "Exchange rate",
  "REVIEW_FEES": "Fees",
  "REVIEW_HOW_THEY_RECEIVE": "How they receive",
  "REVIEW_INSTANTLY": "Instantly",
  "REVIEW_SUBTITLE": "Verify transfer details before continuing",
  "REVIEW_THEY_RECEIVE": "They receive",
  "REVIEW_TITLE": "Review",
  "REVIEW_TOTAL": "Total",
  "REVIEW_YOU_SEND": "You send",
  "RRN_NUMBER": "RRN Number",
  "RRN_NUMBER_PLACEHOLDER": "RRN Number",
  "SEARCH_FOR_A_COMPANY_TO_MAKE_A_PAYMENT": "Search for a company to make a payment",
  "SEARCH_FOR_COMPANY_TO_MAKE_PAYMENT": "Search for a company to make a payment",
  "SELECT_COUNTRY": "Select Country",
  "SELECT_LANGUAGE": "Select language",
  "SELECT_STATE_OF_ISSUE": "Select the state of issue",
  "SEND": "Send",
  "SENDER_ADDRESS": "Address",
  "SENDER_ADDRESS_CITY_PLACEHOLDER": "City",
  "SENDER_ADDRESS_CONTINUE": "Continue",
  "SENDER_ADDRESS_LINE1_PLACEHOLDER": "Address line 1",
  "SENDER_ADDRESS_LINE2_PLACEHOLDER": "Address line 2 (optional)",
  "SENDER_ADDRESS_MANUAL": "Enter address manually",
  "SENDER_ADDRESS_POSTAL_PLACEHOLDER": "Postal code",
  "SENDER_ADDRESS_STATE_PLACEHOLDER": "State",
  "SENDER_ADDRESS_SUBTITLE": "Enter your address",
  "SENDER_ADDRESS_TITLE": "Your address",
  "SENDER_DOB_CANCEL": "Cancel",
  "SENDER_DOB_CONFIRM": "Confirm",
  "SENDER_DOB_CONFIRMATION_TITLE": "Is this your date of birth?",
  "SENDER_DOB_CONFIRM_SUBTITLE": "Make sure your birthday matches your legal ID to avoid money transfer delays.",
  "SENDER_DOB_ERROR_INCOMPLETE": "The date is invalid",
  "SENDER_DOB_ERROR_INVALID": "The date is invalid",
  "SENDER_DOB_ERROR_INVALID_DAY": "The date is invalid (Day)",
  "SENDER_DOB_ERROR_INVALID_MONTH": "The date is invalid (Month)",
  "SENDER_DOB_ERROR_INVALID_YEAR": "The date is invalid (Year)",
  "SENDER_DOB_ERROR_MAX_AGE": "Date of birth cannot indicate an age over {maxAge} years.",
  "SENDER_DOB_ERROR_MIN_AGE": "You must be at least {minAge} years old.",
  "SENDER_DOB_ERROR_NOT_IN_PAST": "Date cannot be equal to or greater than the current date.",
  "SENDER_DOB_ERROR_REQUIRED": "Date of birth is required",
  "SENDER_DOB_MODAL_TITLE": "Confirm your date of birth",
  "SENDER_DOB_SUBTITLE": "This information is to help us identify you",
  "SENDER_DOB_TITLE": "Your date of birth",
  "SENDER_IDENTIFICATION_NUMBER": "Your identification number",
  "SENDER_NAME": "Name",
  "SENDER_NAME_SUBTITLE": "Enter your name",
  "SENDER_NAME_TITLE": "Your name",
  "SEND_CASH": "Send cash",
  "SEND_STATUS_PROCESSING": "Status: Processing",
  "SHARE_RECEIPT": "Share receipt",
  "SKIP": "Skip",
  "SLOGAN": "Send. Receive. Pay. All In One Stop.",
  "SPANISH": "Spanish",
  "STATE_STEP_TITLE": "Choose state",
  "STATUS": "Status:",
  "STATUS_PROCESSING": "Status: Available for pickup",
  "STRKEY_CONTINUE": "Continue",
  "STRKEY_ENTER_PHONE_NUMBER": "Enter your phone number",
  "STRKEY_LOADING": "Loading...",
  "STRKEY_PHONENUMBER": "Phone Number",
  "STRKEY_SUBMIT": "Submit",
  "TELL_US_ABOUT_RECEIVER": "Tell us about your receiver",
  "TELL_US_ABOUT_YOUSELF": "Tell us about yourself",
  "TELL_US_MORE_ABOUT_TRANSACTION": "Tell us more about this transaction",
  "TERMS_AND_CONDITIONS": "I agree to MoneyGram’s Terms and Conditions and confirm I am the sole beneficial owner of the assets, and am acting solely on my own profile. By continuing with this transaction I consent to the collection, use, disclosure, and transfer (including cross-border transfer) of my personal information as described in our Privacy Policy.",
  "TERMS_EXCHANGE_POLICY": "Exchange rate In addition to transfer fees, a currency exchange rate, also determined by MoneyGram, may also apply. MoneyGram may also make money from currency exchange. When selecting a money transfer operator, carefully compare both transfer fees and currency exchange rates. Transfer fees may vary depending on the amount being transferred and the delivery method. Transfer fee and currency exchange rate may be subject to change by MoneyGram without notice.",
  "THANK_YOU_MONEYGRAM": "Thank you from MoneyGram",
  "THEY_RECEIVE": "They receive",
  "TOTAL_INCLUDES_FESS": "Total (includes fees*)",
  "TRANSACTION_SECURE_AND_PREVENT_FRAUD": "This helps us keep your transaction secure and prevent fraud.",
  "TRANSFER_COMPLETE": "Transfer complete",
  "TRANSFER_DETAILS": "Transfer details",
  "TRANSFER_SPEED": "Transfer speed depends on the delivery method, transaction review, and system availability of MoneyGram and its partners.",
  "US_DRIVERS_LICENSE_NUMBER": "US Drivers License Number",
  "US_FED_REMITTANCE_TAX": "U.S. Fed Remittance Tax",
  "VIEW_DETAILS": "View details",
  "WE_NEED_FEW_MORE_DETAILS": "We need a few more details",
  "WE_NEED_FEW_MORE_DETAILS_ABOUT_YOUR_RECEIVER": "We need a few more details about your receiver",
  "WHAT_DO_I_SAY": "What do I say?",
  "WILL_RECEIVE": "will receive",
  "WITHDRAWAL_METHOD": "Withdrawal method",
  "YOUR_ACCOUNT_LOCKED": "Your account is locked",
  "YOUR_INFO": "Your info",
  "YOUR_INFO_IS_ALWAYS_KEPT_PRIVATE": "We use this to prevent fraud. Your info is always kept private.",
  "YOUR_RECEIVER_NAME_MUST_MATCH": "Your receiver’s name must match what’s on their legal ID.",
  "YOUR_STATE_OF_ID": "Your state ID",
  "YOUR_ZIP_CODE": "Your zip code",
  "YOU_ARE_SENDING_TO": "You're sending to",
  "YOU_CAN_CONTINUE_AS_GUEST": "Select Guest if you would like to continue or Reset PIN to link your account",
  "YOU_SEND": "You send",
  "YOU_SENT": "You sent",
  "YOU_WILL_RECEIVE": "You will receive",
  "YOU_WITHDRAW": "You withdrew",
  "ZIP_CODE_DIGIT": "5-digit zip code",
  "delivery:Account Deposit": "Account Deposit",
  "delivery:BANK_DEPOSIT": "Account Deposit",
  "delivery:CASH_PICKUP": "Cash Pickup",
  "delivery:CASH_PICKUP_SUBTITLE": "Choose a location for cash pickup",
  "delivery:CASH_PICKUP_TITLE": "Cash at Location",
  "delivery:Cash Pickup": "Cash Pickup",
  "delivery:Cash Pickup – Anywhere/10 Minute Service": "Cash Pickup – Anywhere/10 Minute Service",
  "delivery:DIRECT_TO_ACCT": "Send to Wallet",
  "delivery:HDS_USD": "Home Delivery USD",
  "delivery:Home Delivery": "Home Delivery",
  "delivery:MOBILE_WALLET_DEPOSIT": "Mobile Wallet Deposit",
  "delivery:MOBILE_WALLET_SUBTITLE": "Mobile Wallet SubTitle",
  "delivery:MOBILE_WALLET_TITLE": "Mobile Wallet",
  "delivery:Mobile Wallet Deposit": "Mobile Wallet Deposit",
  "delivery:Send to Wallet": "Send to Wallet",
  "delivery:WILLCALL_TO": "Cash Pickup",
  "delivery:WILL_CALL": "Cash Pickup - Anywhere/10 Minute Service",
  "receiverLastName2": "Nickname (optional)",
} as const;

export type LegacyMessageId = keyof typeof legacyMessageSource;
